import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { OAuthButtons } from '../../components/auth/OAuthButtons';
import { FormError, OrDivider, PasswordField, SubmitButton, TextField, scorePassword } from '../../components/auth/FormFields';
import { authApi, readApiError } from '../../lib/auth-api';

export function SignupPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [terms, setTerms] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    if (scorePassword(password) < 2) {
      setErr(t('auth.errorPasswordWeak'));
      return;
    }
    if (!terms) {
      setErr(t('auth.errorAgreeTerms'));
      return;
    }
    setBusy(true);
    try {
      await authApi.register({ email, password, name });
      navigate('/onboarding');
    } catch (e) {
      setErr(readApiError(e, t('auth.errorGeneric')));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      eyebrow={t('auth.signUpEyebrow')}
      title={t('auth.signUpTitle')}
      subtitle={t('auth.signUpSubtitle')}
      altCta={{ to: '/login', helper: t('auth.haveAccount'), label: t('auth.signInLink') }}
    >
      <OAuthButtons context="signup" />
      <OrDivider label={t('auth.or')} />
      <form onSubmit={onSubmit} className="space-y-4">
        <TextField
          label={t('auth.fullName')}
          autoComplete="name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          label={t('common.email')}
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <PasswordField
          label={t('auth.password')}
          autoComplete="new-password"
          required
          showStrength
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label className="flex items-start gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={terms}
            onChange={(e) => setTerms(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-border accent-accent-600"
          />
          <span>{t('auth.termsAgreement')}</span>
        </label>
        {err && <FormError>{err}</FormError>}
        <SubmitButton loading={busy}>{t('auth.signUpButton')}</SubmitButton>
      </form>
      <p className="mt-4 text-xs text-muted-foreground text-center">{t('freeForever')}</p>
    </AuthLayout>
  );
}
